<template>
  <v-card class="p-4" :loading="loadingFile">
    <v-toolbar :class="loadingFile ? 'mt-2' : ''" dark color="primary">
      <v-btn icon dark @click="fecharModal()">
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <v-toolbar-title style="font-size: large">
        Editar {{ alvara.tipoAlvara }} - {{ empresaId }}
      </v-toolbar-title>
    </v-toolbar>
    
    <div v-if="loadingFile" class="row justify-center" style="margin-top:10%">
  <v-progress-circular
    :size="300"
    indeterminate
    color="primary"
  ></v-progress-circular>
</div>
     <div class="flex flex-col p-5" v-else>
      <div v-if="alvaraAtual != null">
        <div v-for="(log, index) in alvara.activities" :key="index">
          <b-tag :type="log | statusType">
            {{ log.description == "created" ? "Criou" : "Atualizou" }}</b-tag
          >
          {{ log.nome_completo }}
        </div>
      </div>
      <div class="w-full flex justify-between items-center">
        <p class="px-2 text-xl font-display mb-4">{{ alvara.tipoAlvara }}</p>

        <Label class="mb-3" for="ficticio">
          <input
            style="font-size: 20px"
            type="checkbox"
            id="ficticio"
            v-model="ficticio"
            class="form-control"
          />
          Sem Alvara Só ter taxas
        </Label>
        <Label v-if="alvara.tipoAlvara == 'alvara'" class="mb-3" for="checkbox">
          <input
            style="font-size: 20px"
            type="checkbox"
            id="checkbox"
            v-model="alvaraDefinitivo"
            class="form-control"
            @click="alvaraProvisorio = false"
          />
          Alvara Definitivo
        </Label>
        <Label v-if="alvara.tipoAlvara == 'alvara'" class="mb-3" for="checkbox">
          <input
            style="font-size: 20px"
            type="checkbox"
            id="checkbox"
            v-model="alvaraProvisorio"
            class="form-control"
            @click="alvaraDefinitivo = false"
          />
          Alvara Provisorio
        </Label>
      </div>

      <form class="flex flex-col">
        <label class="flex flex-col pb-5">
          <Lynx-Label label="Data de vencimento" />
          <b-datepicker
            :years-range="[-1, 5]"
            v-model="form.data_vencimento"
            :day-names="dayNames"
            :month-names="monthNames"
          />
        </label>

        <b-field class="file" required>
          <b-upload v-model="form.file">
            <a class="button is-primary">
              <b-icon icon="upload"></b-icon>
              <span>Realizar upload</span>
            </a>
          </b-upload>
          <span class="file-name" v-if="form.file">
            {{ form.file.name }}
          </span>
          <span
            class="file-name cursor-pointer"
            v-if="!form.file && arquivo"
            @click="openFile()"
          >
            {{ arquivo.nome }}
            <b-icon icon="attachment"></b-icon>
          </span>
        </b-field>
      </form>

      <Lynx-Button
        class="self-end"
        :text="alvaraAtual ? 'Atualizar' : 'Cria'"
        icon="Check"
        :loading="loadingButton"
        @click.native="salvar(alvaraAtual ? 'Atualizar' : 'Cria')"
      />
      <Lynx-Button
        v-if="alvaraAtual"
        class="self-end mt-2"
        text="Criar novo Alvara"
        icon="Plus"
        :loading="loadingButton"
        @click.native="criarNovoAlvara"
      />

      <div>
        <Lynx-Button
          v-if="alvaraAtual"
          class="mt-2"
          :text="verTaxas ? 'Recolher taxas' : 'Expandir taxas'"
          icon="Plus"
          :loading="loadingButton"
          @click.native="verTaxas = !verTaxas"
        />

        <TaxaPadrao
          v-if="verTaxas"
          :alvara-atual="alvaraAtual"
          :alvara="alvara.tipoAlvara"
        />
      </div>
    </div> 
  
  </v-card>
</template>

<script>
import InputMoney from "../../../components/helpers/InputMoney";
import { showDocumento, storeDocumento, updateDocumento } from "./methods.js";
import { monthNames, dayNames } from "@/utils/utils";
import moment from "moment";
import base64Files from "../../../mixins/base64Files";
import { mapGetters } from "vuex";
import LynxTextarea from "@/components/helpers/Textarea";
import { hasRole } from "@/utils/can";
import Logs from "./Logs.vue";
import { TipoTaxasEnum } from "@/utils/enum";
import TaxaPadrao from "@/views/taxas/TaxaPadrao";

export default {
  name: "AlvaraPadrao",
  mixins: [base64Files],
  components: { LynxTextarea, Logs, InputMoney, TaxaPadrao },

  props: {
    alvara: {
      required: null,
      type: Object,
    },
    empresaId: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      modelLogs: false,
      logs: {},
      alvaraDefinitivo: null,
      alvaraProvisorio: null,
      arquivo: null,
      arquivoTaxa: null,
      novoAlvara: false,
      loadingFile: false,
      loadingButton: false,
      monthNames,
      dayNames,
      verTaxas: false,
      form: {
        empresa_id: this.empresaId,
        data_vencimento: new Date(),
        definitivo: null,
      },
      errorMessage: "Não foi possivel editar o alvará",
      taxasOptions: TipoTaxasEnum,
      ficticio: false,
      lista_taxas: [],
    };
  },
  computed: {
    alvaraAtual() {
      return this.novoAlvara ? null : this.alvara;
    },
    ...mapGetters(["getToken"]),
  },
  filters: {
    statusType: (val) => {
      if (val.description === "created") {
        return "is-success";
      }
      if (val.description === "updated") {
        return "is-info";
      }

      return "default";
    },
    formatDateToBr(val) {
      return moment(val).format("DD/MM/YYYY");
    },
    formatMoneyBr: (value) => {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
  methods: {
    hasRole,
    async fetchFile() {
      this.loadingFile = true;
      if (this.alvaraAtual != null && this.alvaraAtual.id) {
        this.arquivo = await showDocumento(
          this.alvara.tipoAlvara,
          this.alvaraAtual.id
        );
      }

      this.loadingFile = false;
    },

    salvar(tipo) {
      let message;
      if (this.ficticio) {
        if (this.alvaraAtual == null) {
          message =
            "Essa ação irá criar um alvará fictício sem dados. Deseja continuar?";
        } else {
          message =
            "Essa ação irá remover os dados do alvará tornando-o fictício. Deseja continuar?";
        }
      } else {
        message = "Deseja realmente " + tipo + " o alvara?";
      }

      // TODO: remover caso não formos usar e adicionar no componente atual tudo que tem nesse outro 
      // this.$buefy.dialog.confirm({
      //   message: message,
      //   confirmText: "Salvar",
      //   cancelText: "Cancelar",
      //   type: "is-warning",
      //   onConfirm: () => this.onSubmit(),
      // });

      this.$confirm({
        title: 'Você confirmar a ação?',
        message: message,
        type: "is-warning",
        onConfirm: () => {
          this.onSubmit();
        },
        onCancel: () => {
        this.$snack.error("Ação cancelada pelo usuário");
        }
      });
    },
    async onSubmit() {
      this.loadingButton = true;
      let form;
      if (this.form.file) {
        form = {
          ...this.form,
          file: await this.convertFileToBase64(this.form.file),
          data_vencimento: this.form.data_vencimento
            ? moment(this.form.data_vencimento).format("YYYY-MM-DD")
            : null,
          ficticio: this.ficticio ? 1 : 0,
          definitivo: this.alvaraAtualDefinitivo ? 1 : 0,
        };
      } else {
        form = {
          ...this.form,
          data_vencimento: this.form.data_vencimento
            ? moment(this.form.data_vencimento).format("YYYY-MM-DD")
            : null,
          ficticio: this.ficticio ? 1 : 0,
          definitivo: this.alvaraAtualDefinitivo == true ? 1 : 0,
        };
      }

      if (this.alvaraAtual == null) {
        storeDocumento(this.alvara.tipoAlvara, form)
          .then(() => {
            this.$snack.success("Alvará criado com sucesso");
          })
          .catch((err) =>
            this.$snack.error(err.response.data.message || this.errorMessage)
          )
          .finally(() => (this.loadingButton = false));
      } else {
        updateDocumento(this.alvara.tipoAlvara, this.alvaraAtual.id, form)
          .then(() => {
            // this.$emit("edit-alvara");
            this.$snack.success("Alvará  atualizado com sucesso");
          })
          .catch((err) =>
            this.$snack.error(err.response.data.message || this.errorMessage)
          )
          .finally(() => (this.loadingButton = false));
      }

      this.$emit("edit-alvara");
    },

    openFile() {
      window.open(
        `${process.env.VUE_APP_API_URL}/arquivos/${this.arquivo.id}/open?token=${this.getToken}`
      );
    },

    openModelLogs(value) {
      this.modelLogs = true;
      this.logs = value.logs;
    },
    hide() {
      this.modelLogs = false;
    },
    criarNovoAlvara() {
      this.novoAlvara = true;
      this.arquivo = null;
      this.form = {
        empresa_id: this.empresaId,
        data_vencimento: new Date(),
      };
    },
    fecharModal() {
      this.$emit("fechar-modal");
    },
  },
  beforeMount() {
    if (this.alvaraAtual != null) {
      if (this.alvaraAtual.data_vencimento != null) {
        this.form = {
          empresa_id: this.empresaId,
          data_vencimento: new Date(moment(this.alvaraAtual.data_vencimento)),
          definitivo: this.alvaraAtual.definitivo == 1,
        };

        this.alvaraAtualDefinitivo = this.alvaraAtual.definitivo == 1;
        this.alvaraAtualProvisorio = this.alvaraAtual.definitivo == null;

        // }else{
        //     this.form = {
        //     empresa_id: this.empresaId,
        //     data_vencimento: new Date(),
        //   };
      }
    } else {
      this.form = {
        empresa_id: this.empresaId,
        data_vencimento: null,
      };
    }

    // if (this.form.data_vencimento < new Date())
    //   this.form.data_vencimento = null;
  },
  mounted() {
    this.fetchFile();
  },
};
</script>

<style scoped>
.v-line {
  height: 0.1vw;
  width: 100%;
  border-width: 0;
  color: rgb(63, 62, 62);
  background-color: rgb(35, 34, 34);
}
</style>
